import { useState } from 'react'

//Components
import SelectAddress from 'pages/dashboard/e-reporting/forms/components/reuseables/select-address/SelectAddress'

//Hoc
import withFetch from './withFetch'

//Context
import { STEPS, useFormMethod, useFormState } from "pages/dashboard/e-reporting/forms/context";

function PilihProvinsiProperti({ data }) {
  //Context
  const { setCurrentStep, formHandler, handlePrevState } = useFormMethod();
  const { disabledAll, form } = useFormState()

  const [selectedData, setSelectedData] = useState({
    ...form.provinsi_properti.value,
    value: form.provinsi_properti.value.id,
    label: form.provinsi_properti.value.name
  })

  const onNext = () => {
    handlePrevState()
    formHandler('provinsi_properti', selectedData)
    setCurrentStep(STEPS.pilihKotaProperti)
  }

  return (
    <SelectAddress
      question={'Di provinsi mana properti?'}
      placeholder="Pilih provinsi"
      required
      data={data}
      selectedData={selectedData}
      setSelectedData={setSelectedData}
      onNext={onNext}
      disabled={disabledAll}
    />
  )
}

export default withFetch(PilihProvinsiProperti)